<template>
  <footer class="footer">
    <span>&copy; 2018 易才宏业保险经纪有限公司</span>
    <span class="footer-contact">地址：天津市河西区黑牛城道与洞庭路交口东南侧五福大厦-1-1407、-1-1408
      <span class="footer-phone">举报电话：4006-234-345</span>
      <span class="footer-phone">举报邮箱：jianyi@chinatalentgroup.com</span>
      <span class="footer-phone">
        <router-link to="/information?tab=3" style="color: #999999">隐私政策</router-link>
      </span>
    </span>
    <div>
      <a style="color:#999" href="https://beian.miit.gov.cn/" target="blank">津ICP备16005555号-2</a>
      <a style="color:#999" href="https://beian.mps.gov.cn/#/query/webSearch" target="blank"><img width="16" src='	https://beian.mps.gov.cn/img/logo01.dd7ff50e.png' /> 津公网安备12010302002608</a>
    </div>
  </footer>
</template>
<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  height: 131px;
  font-size: 12px;
  line-height: 17px;
  color: $font-color3;
  background-color: $bg-dark-color;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .footer-contact{
    text-align: center;
  }
  .footer-phone {
    margin-left: 2em;
    @media screen and (max-width: 900px) {
      display: inline-block;
    }
  }
}
</style>

